import { Button } from '@mui/material';
import React, { memo, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BaseTable from 'components/ui/tables/BaseTable';
import useTopPanel from 'hooks/useTopPanel';
import ViewOrder from './items/view';
import SimpleSearchInput from 'components/SearchInputNavbar';
import ChangeStatus from './items/change-status';
import OrderFilterDrawer from 'components/dashboard/OrderFilterDrawer';
import OrderStatusFilterComponent from '../../../components/ui/filters/OrderStatusFilterComponent';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

const Warehouse = () => {
  const { setComponent } = useTopPanel();
  const navigate = useNavigate();

  const [statusModal, setStatusModal] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [itemData, setItemData] = useState('');
  const [open, setOpen] = useState(false);
  const [hasError, setHasError] = useState();
  const axiosPrivate = useAxiosPrivate();

  const { isLoading, data } = useQuery({
    queryKey: '/dictionary/orders-tatuses',
    queryFn: async () => {
      const res = await axiosPrivate.get('/dictionary/orders-tatuses');
      return res.data.data;
    },
    enabled: !hasError,
    onError: () => setHasError(true),
    retry: false,
  });

  const onAdd = () => {
    navigate(`add`);
  };
  const onUpdate = (data) => {
    navigate(`${data?.id}/edit`);
  };

  useEffect(() => {
    setComponent(<div className='component-title'>Buyurtmalar</div>);
  }, []);

  const paymentTypeVariants = useMemo(() => {
    const colors = ['default', 'info', 'secondary', 'success'];
    if (!data?.length) return [];
    return data?.map(({ id, name }, i) => ({
      code: id,
      label: name,
      color: colors?.[i],
    }));
  }, [data]);

  const actionsList = [
    {
      icon: 'bi bi-eye',
      btnColor: 'info',
      code: 'ORDER_VIEW',
      setOpen: setOpenModal,
      setData: setItemData,
    },
    {
      icon: 'bi bi-gear',
      btnColor: 'primary',
      code: 'ORDER_CHANGE',
      setOpen: setStatusModal,
      setData: setItemData,
    },
    {
      icon: 'bi bi-pencil-square',
      btnColor: 'info',
      code: 'ORDER_EDIT',
      setOpen: () => {},
      setData: onUpdate,
    },
  ];

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container py-3 flex flex-row items-center'>
          <div className='header-actions filter-box flex gap-2 items-center px-4 w-full'>
            <Button
              variant='base'
              color='primary'
              className='!min-w-[80px]'
              startIcon={<i className='bi bi-filter' />}
              onClick={() => setOpenFilter(true)}
            >
              Filter
            </Button>
            <SimpleSearchInput inputKey='name' />
            <OrderStatusFilterComponent isLoading={isLoading} data={data} />
          </div>
          <div className='header-actions action-buttons-box py-3 px-4 flex items-center justify-center'>
            <Button
              variant='base'
              color='info'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='success'
              className='!mx-2'
              onClick={() => onAdd()}
            >
              <i className='bi bi-plus-circle' />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper h-[calc(100vh-180px)]'>
        <BaseTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/orders/index'
          emitTableColumns={{ open, setOpen }}
          tableName='outcomes'
          headCells={[
            { code: 'date', label: 'Sana' },
            { code: 'until_date', label: 'Yetkazib berish sanasi' },
            { code: 'user', label: 'Mijoz' },
            { code: 'deliver', label: 'Yetkazib beruvchi' },
            { code: 'status', label: 'Status' },
            { code: 'sum', label: 'Summasi' },
          ]}
          columns={[
            { code: 'date', type: 'date' },
            { code: 'until_date', type: 'date' },
            {
              code: 'user',
              type: 'nested',
              childStr: 'name',
            },
            {
              code: 'deliver',
              type: 'nested',
              childStr: 'name',
            },
            {
              code: 'status',
              type: 'customStatus',
              variants: paymentTypeVariants,
            },
            { code: 'totalsum', type: 'price' },
          ]}
          actionsList={actionsList}
        />
      </div>

      <ViewOrder
        open={openModal}
        setOpen={setOpenModal}
        itemData={itemData}
        setItemData={setItemData}
        setRefetch={setRefetch}
      />

      <ChangeStatus
        open={statusModal}
        setOpen={setStatusModal}
        itemData={itemData}
        setItemData={setItemData}
        setRefetch={setRefetch}
      />
      <OrderFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Warehouse);
